import {
    Component,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    input,
    model,
    viewChild,
    ElementRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { PopoverModule, Popover } from 'primeng/popover';
import { FocusTrapModule } from 'primeng/focustrap';
import { TableWrapperHeader } from '@client/app/shared-modules/table/components/table-wrapper.component';

@Component({
    selector: 'mon-column-selector',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TranslocoModule,
        Button,
        CheckboxModule,
        PopoverModule,
        FocusTrapModule,
    ],
    templateUrl: './column-selector.component.html',
    styleUrl: './column-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ColumnSelectorComponent<T> {
    tableKey = input.required<string>();
    columns = input.required<TableWrapperHeader<T>[]>();
    selectedColumns = model.required<TableWrapperHeader<T>[]>();

    private readonly popover = viewChild.required<Popover>('popover');
    private readonly content = viewChild<ElementRef<HTMLElement>>('popoverContent');
    private readonly triggerButton = viewChild.required<Button>('triggerButton');

    toggle (event: Event): void {
        this.popover().toggle(event);
    }

    onPopoverShow (): void {
        setTimeout(() => {
            const container = this.content()?.nativeElement;
            if (container) {
                const firstCheckbox = container.querySelector<HTMLElement>('input[type="checkbox"]');
                if (firstCheckbox) {
                    firstCheckbox.focus();
                } else {
                    container.focus();
                }
            }
        });
    }

    onPopoverHide (): void {
        this.focusTrigger();
    }

    onContentKeydown (event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.popover().hide();
            this.focusTrigger();
        }
    }

    focusTrigger (): void {
        const host = this.triggerButton().el?.nativeElement as HTMLElement | undefined;
        (host?.querySelector('button') as HTMLElement | null)?.focus();
    }
}
